import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Body} from 'shells/typography/body';

type Props = {
    title: string;
    description: string;
};

export function AssignmentTableEmptyState(props: Props) {
    return (
        <div className='pad-16'>
            <StackLegacy spacing={4} alignCenter={true}>
                <Body size='large' color='light' isBold={true}>
                    {props.title}
                </Body>
                <Body color='light'>{props.description}</Body>
            </StackLegacy>
        </div>
    );
}
